import React from 'react';
import { QuickLinks } from '../components/QuickLinks';
import { PortfolioGrid } from '../components/PortfolioGrid';
import { SectionHeading } from '../components/SectionHeading';
import { ArtistCard } from '../components/ArtistCard';
import { Link } from 'react-router-dom';
import { FeaturedProductCard } from '../components/shop/FeaturedProductCard';
import { Button } from '../components/Button';
import { images } from '../data/images';
import { shopEvents, walkInNotice } from '../data/site';
import { portfolio } from '../data/portfolio';
import { artists } from '../data/artists';
import { products } from '../data/products';
export function Home() {
  return <>
      <section className="relative isolate flex min-h-[560px] w-full items-center overflow-hidden bg-black lg:aspect-[2.6/1] lg:min-h-[520px]" data-id="element-384" data-mp="2dhgrb1wthu9k">
        <img src={images.hero} alt="Tattooed pin-up model in front of the Las Vegas Strip skyline at night" className="absolute inset-0 -z-10 h-full w-full object-cover object-[72%_top] lg:object-top" data-id="element-385" data-mp="3kuiixie6yq8f" />
        <div className="absolute inset-0 -z-10 bg-black/55 lg:hidden" data-id="element-386" data-mp="30uf7k4edtp30" />
        <div className="w-full px-6 pb-12 pt-28 md:px-[6.5vw] lg:pb-0 lg:pt-16" data-id="element-387" data-mp="2vyhtk4qlcute">
          <div className="max-w-[640px]" data-id="element-388" data-mp="2qxak818svnkm">
            <p className="font-script text-base italic tracking-[0.06em] md:text-lg" data-id="element-389" data-mp="2r0g8je9lulfa">Meet the best Tattoo Artists in World!</p>
            <h1 className="mt-1 whitespace-nowrap font-slab text-[40px] font-bold uppercase leading-tight tracking-[0.1em] sm:text-6xl xl:text-[66px]" data-id="element-390" data-mp="2hyfhx08vmxml">
              Trip Ink Tattoo
            </h1>
            <p className="mt-3 max-w-[590px] text-[15px] font-light leading-[1.6] md:text-base" data-id="element-391" data-mp="287ktbp85rlxz">
              If you are looking for the best Tattoo Artists on the Las Vegas Strip, then you have come to the right place! Trip Ink Tattoo is one of THE BEST Las
              Vegas Tattoo Shops on the Strip.
            </p>
          </div>
        </div>
      </section>

      <section className="px-6 py-16" aria-label="Walk-in availability" data-id="element-392" data-mp="1uap70v2wbxzz">
        <div className="mx-auto max-w-[990px] border border-white/80 px-6 py-5 text-center md:px-14" data-id="element-393" data-mp="1kj5vdxllx9kb">
          <p className="font-slab text-sm font-bold uppercase leading-[2.1] tracking-[0.2em] md:text-base" data-id="element-394" data-mp="1onnahjh0uyor">{walkInNotice}</p>
        </div>
      </section>

      <section className="py-16" aria-label="Get started" data-id="element-395" data-mp="1fl4cpds3fc9d">
        <QuickLinks data-id="element-396" data-mp="1fnqj3a38zlq0" />
      </section>

      <section className="py-20" aria-labelledby="skills-heading" data-id="element-397" data-mp="23aowtzzzgfk8">
        <div className="px-6" data-id="element-398" data-mp="23dktzm40b07m">
          <SectionHeading title="See The Skills" text="Here are the glimpse of exponential work done by the Tattoo Artists" data-id="element-399" data-mp="28akyhsl7juwm" />
        </div>
        <div className="mx-auto mt-12 max-w-[1400px] px-1" data-id="element-400" data-mp="1tl5a2j95g1k3">
          <PortfolioGrid items={portfolio.slice(0, 12)} data-id="element-401" data-mp="1yjqc8o7yovb6" />
        </div>
        <div className="mt-10 text-center" data-id="element-402" data-mp="2ma2twqt0e6ey">
          <Button to="/portfolio" variant="outline" data-id="element-403" data-mp="2m9avl8811ukz">
            View the full portfolio
          </Button>
        </div>
      </section>

      <section className="border-y border-ink-line bg-ink-surface py-16" aria-label="Upcoming events" data-id="element-404" data-mp="2r2vtz1dj8qkp">
        <div className="mx-auto grid max-w-5xl gap-10 px-6 md:grid-cols-2" data-id="element-405" data-mp="fjhajzd3yhs3">
          {shopEvents.map(event => <div key={event.date} className="flex gap-6" data-id="element-406" data-mp="odw14y339eqi">
              <p className="w-28 shrink-0 font-slab text-2xl font-bold uppercase leading-tight tracking-[0.1em]" data-id="element-407" data-mp="odcgh9m20c8s">{event.date}</p>
              <p className="border-l border-ink-line pl-6 leading-relaxed text-ink-muted" data-id="element-408" data-mp="3sscb10mi6izl">{event.text}</p>
            </div>)}
        </div>
      </section>

      <section className="py-20" aria-labelledby="shop-heading" data-id="element-409" data-mp="3nutzr3l0jrof">
        <div className="mx-auto max-w-[1000px] px-6 text-center" data-id="element-410" data-mp="5nwe0gqt69pq">
          <p className="font-script text-base italic text-ink-muted" data-id="element-411" data-mp="ojgn22b9k8w">Shop Now</p>
          <h2 id="shop-heading" className="mx-auto mt-2 max-w-[560px] font-slab text-3xl font-bold uppercase leading-[1.3] tracking-[0.2em] md:text-[38px]" data-id="element-412" data-mp="qnx0jhecbq2">
            Best Tattoo Shops In Las Vegas
          </h2>
          <Link to="/shop" className="mt-10 inline-block border border-white px-10 py-4 font-slab text-sm font-bold uppercase tracking-[0.25em] transition-colors duration-150 ease-out hover:bg-white hover:text-ink" data-id="element-413" data-mp="27dwkenfrlaxc">
            View All Products
          </Link>
          <div className="mt-14 grid gap-12 text-left sm:grid-cols-3 sm:gap-0" data-id="element-414" data-mp="2hef9bwm6rhm4">
            {products.filter(p => p.featured).map(product => <FeaturedProductCard key={product.slug} product={product} data-id="element-415" data-mp="2qaod1nh752e2" />)}
          </div>
        </div>
      </section>

      <section className="border-t border-ink-line py-20" aria-labelledby="artists-heading" data-id="element-416" data-mp="302u4mw3jdhsq">
        <div className="mx-auto max-w-6xl px-6" data-id="element-417" data-mp="351dqyxm1kvlm">
          <SectionHeading title="Resident Artists" text="Our shop is Artist owned and operated and we work with the most acclaimed, top notch, powerhouse Tattoo Artists. From beginning to end, we strive to give you the best experience possible as you leave wanting more!" data-id="element-418" data-mp="3513z14hfseda" />
          <div className="mt-14 grid gap-x-6 gap-y-12 sm:grid-cols-2 lg:grid-cols-4" data-id="element-419" data-mp="12gb2uaxfi8rs">
            {artists.map(artist => <ArtistCard key={artist.slug} artist={artist} data-id="element-420" data-mp="tea75ihufus8" />)}
          </div>
        </div>
      </section>
    </>;
}